export function initWorkPreviews(areas, reducedMotion) {
  const cleanups = [];
  for (const area of areas) {
    const movie = area.querySelector('video');
    let hovering = false;
    let failed = false;
    const hide = () => {
      area.classList.remove('is-preview-playing');
      movie.pause();
    };
    const enter = (event) => {
      if (event.pointerType === 'touch' || reducedMotion.matches || failed) return;
      hovering = true;
      if (!movie.getAttribute('src')) movie.src = movie.dataset.previewSrc;
      movie.currentTime = 0;
      movie.play().catch(hide);
    };
    const leave = () => { hovering = false; hide(); };
    const playing = () => {
      if (hovering && !document.hidden && !reducedMotion.matches) area.classList.add('is-preview-playing');
      else hide();
    };
    const error = () => { failed = true; leave(); };
    const visibility = () => { if (document.hidden) leave(); };
    const motion = () => { if (reducedMotion.matches) leave(); };
    const listeners = [
      [area, 'pointerenter', enter], [area, 'pointerleave', leave],
      [movie, 'playing', playing], [movie, 'error', error],
      [document, 'visibilitychange', visibility], [reducedMotion, 'change', motion],
    ];
    listeners.forEach(([target, type, callback]) => target.addEventListener(type, callback));
    cleanups.push(() => {
      leave();
      listeners.forEach(([target, type, callback]) => target.removeEventListener(type, callback));
    });
  }
  return () => cleanups.forEach((cleanup) => cleanup());
}
